class RecipientForm extends HTMLElement {
  constructor() {
    super();
    this.recipientFields = this.querySelector('.recipient-fields');
    this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.dataset.sectionId}`);
    this.checkboxInput.disabled = false;
    this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
    this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
    this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
    this.sendDateInput = this.querySelector(`#Recipient-send-date-${this.dataset.sectionId}`);
    this.addEventListener('change', this.onChange.bind(this));
    this.onChange();
  }

  onChange() {
    if (this.checkboxInput.checked) {
      this.enableInputFields();
      this.recipientFields.style.display = 'block';
    } else {
      this.clearInputFields();
      this.disableInputFields();
      this.recipientFields.style.display = 'none';
      this.updateSendDateLabel();
    }

    this.updateSendDateLabel();
  }

  updateSendDateLabel() {
    this.sendDateInput.parentElement.querySelector('.field__label').textContent = this.sendDateInput.value ? this.sendDateInput.value : this.sendDateInput.placeholder;
  }

  inputFields() {
    return [this.emailInput, this.nameInput, this.messageInput, this.sendDateInput];
  }

  disableableFields() {
    return [...this.inputFields()];
  }

  clearInputFields() {
    this.inputFields().forEach((field) => (field.value = ''));
  }

  enableInputFields() {
    this.disableableFields().forEach((field) => (field.disabled = false));
  }

  disableInputFields() {
    this.disableableFields().forEach((field) => (field.disabled = true));
  }
}

customElements.define('recipient-form', RecipientForm);
